export const tokens = {
  rewardToken: {
    token: "GUILD",
    address: "0x0565805CA3A4105FAEE51983b0bD8ffB5ce1455C",
    decimals: 18,
  },
};
